// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import inquiryAnswerEntity from './entities/inquiry-answer.json';
import inquiryAnswerMenu from '../pages/inquiry-answer/menu.json';
import inquiryAnswerFullForm from '../pages/inquiry-answer/forms/full.json';
import inquiryAnswerContextForm from '../pages/inquiry-answer/forms/context.json';
import inquiryAnswerMiniForm from '../pages/inquiry-answer/forms/mini.json';
import inquiryAnswerLookupForm from '../pages/inquiry-answer/forms/lookup.json';
import inquiryAnswerTableView from '../pages/inquiry-answer/views/table.json';
import inquiryAnswerCardsView from '../pages/inquiry-answer/views/cards.json';
import inquiryAnswerCalendarView from '../pages/inquiry-answer/views/calendar.json';
import inquiryAnswerDashboardView from '../pages/inquiry-answer/views/dashboard.json';

/** Тип запису «Відповідь» зі сторінками пакета: меню, форми та подання з pages/inquiry-answer/. */
export const inquiryAnswerDefinition: IRecordTypeDefinition = {
  ...inquiryAnswerEntity,
  views: assembleViewSet({
      table: inquiryAnswerTableView,
      cards: inquiryAnswerCardsView,
      calendar: inquiryAnswerCalendarView,
      dashboard: inquiryAnswerDashboardView,
  }),
  form: inquiryAnswerFullForm,
  forms: { full: inquiryAnswerFullForm, context: inquiryAnswerContextForm, mini: inquiryAnswerMiniForm, lookup: inquiryAnswerLookupForm },
  menu: inquiryAnswerMenu,
} as IRecordTypeDefinition;
